import { ofType, combineEpics } from 'redux-observable';
import { filter, map } from 'rxjs/operators';
import parse from 'date-fns/parse';
import addHours from 'date-fns/addHours';
import format from 'date-fns/format';
import isBefore from 'date-fns/isBefore';

import get from 'lodash/get';

import {
    NODE_NAME_DATE_RANGE_START_DATE,
    NODE_NAME_DATE_RANGE_END_DATE,
    NODE_NAME_DATE_RANGE_START_TIME,
    NODE_NAME_DATE_RANGE_END_TIME,
} from 'common/entities/formNode/nodeNames';
import { getFormNode, getAllFormNodes } from 'common/entities/formNode/selectors';

import { UPDATE_FORM_VALUE } from '../constants/actionTypes';
import { updateFormValue } from '../actions/form';
import { getFormNodeTouched } from '../selectors/form';

// Helper methods

const getDateRangeEndNodeId = (state, dateRangeStartNode, name) => {
    const allFormNodes = getAllFormNodes(state);
    const groupNodeId = get(dateRangeStartNode, 'parent');
    const dateRangeFormNodes = allFormNodes.filter((node) => get(node, 'parent') === groupNodeId);
    const dateRangeEndNode = dateRangeFormNodes.find((node) => get(node, 'name') === name);
    return get(dateRangeEndNode, 'id');
};

const getDateRangeNodeId = (state, action, name) => {
    const id = get(action, 'payload.id');
    const dateRangeStartNode = getFormNode(state, id);
    return getDateRangeEndNodeId(state, dateRangeStartNode, name);
};

const shouldPreFillEndNode = (state, action, startName, endName) => {
    const id = get(action, 'payload.id');
    const dateRangeStartNode = getFormNode(state, id);
    const isDateRangeStartNode = get(dateRangeStartNode, 'name') === startName;
    const dateRangeEndNodeId = getDateRangeEndNodeId(state, dateRangeStartNode, endName);
    const dateRangeEndNodeTouched = getFormNodeTouched(state, {
        id: dateRangeEndNodeId,
    });
    return isDateRangeStartNode && !dateRangeEndNodeTouched;
};

// Epics

const preFillEndDateEpic = (action$, state$) =>
    action$.pipe(
        ofType(UPDATE_FORM_VALUE),
        filter((action) =>
            shouldPreFillEndNode(state$.value, action, NODE_NAME_DATE_RANGE_START_DATE, NODE_NAME_DATE_RANGE_END_DATE),
        ),
        map((action) => {
            const state = state$.value;
            const value = get(action, 'payload.value');
            const nodeId = getDateRangeNodeId(state, action, NODE_NAME_DATE_RANGE_END_DATE);

            return updateFormValue(nodeId, value);
        }),
    );

const preFillEndTimeEpic = (action$, state$) =>
    action$.pipe(
        ofType(UPDATE_FORM_VALUE),
        filter((action) =>
            shouldPreFillEndNode(state$.value, action, NODE_NAME_DATE_RANGE_START_TIME, NODE_NAME_DATE_RANGE_END_TIME),
        ),
        map((action) => {
            const state = state$.value;
            const value = get(action, 'payload.value');
            const nodeId = getDateRangeNodeId(state, action, NODE_NAME_DATE_RANGE_END_TIME);

            const DEFAULT_END_TIME = '11:59PM';
            const TIME_FORMAT = 'h:mma';

            const dateTimeValue = parse(value, TIME_FORMAT, new Date());
            const TEN_PM = parse('10:00PM', TIME_FORMAT, new Date());

            const newTimeValue = isBefore(dateTimeValue, TEN_PM)
                ? format(addHours(dateTimeValue, 2), TIME_FORMAT)
                : DEFAULT_END_TIME;

            return updateFormValue(nodeId, newTimeValue);
        }),
    );

export default combineEpics(preFillEndDateEpic, preFillEndTimeEpic);
